'use client';

import { useState } from 'react';
import { AddressForm } from '../address-form/address-form';
import { ModalNext } from '@instamenu/ui-system-next';
import { Address } from '@instamenu/context-user';
import { observer } from 'mobx-react-lite';
import { AddressButton } from './address-button';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { Fulfillment } from '@instamenu/data-access';
import { AddressCard } from './address-card';
import AddressList from '../address-list/address-list';
import { useUIStateContext } from '../ui-state-context/ui-state-context';

type AddressSelectProps = {
  buttonProps?: React.HTMLAttributes<HTMLDivElement>;
  hasButtonInfo?: boolean;
};

export const AddressSelect = observer((props: AddressSelectProps) => {
  const checkout = useCheckoutContext();
  const { isAddressSelectOpen, setIsAddressSelectOpen } = useUIStateContext();
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(
    checkout?.order.deliveryAddress || null,
  );
  const [toEdit, setToEdit] = useState<Address>();

  const handleClose = () => {
    setIsAddressSelectOpen(false);
    setShowAddressForm(false);
    setSelectedAddress(checkout?.order.deliveryAddress || null);
    setToEdit(undefined);
  };

  if (checkout?.mode !== Fulfillment.Delivery) return null;

  return (
    <>
      {!props.hasButtonInfo ? (
        <AddressButton
          isOpen={isAddressSelectOpen}
          address={checkout.order.deliveryAddress}
          onClick={() => {
            setIsAddressSelectOpen(true);
            if (!checkout.addresses.book.length) setShowAddressForm(true);
          }}
          {...props.buttonProps}
        />
      ) : (
        <AddressCard
          isOpen={isAddressSelectOpen}
          address={checkout.order.deliveryAddress}
          onClick={() => {
            setIsAddressSelectOpen(true);
            if (checkout.addresses.book.length === 0) setShowAddressForm(true);
          }}
          {...props.buttonProps}
        />
      )}

      {isAddressSelectOpen && (
        <>
          {checkout.addresses.book.length > 0 && !showAddressForm ? (
            <AddressList
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              checkout={checkout}
              isOpen={isAddressSelectOpen}
              setIsOpen={setIsAddressSelectOpen}
              setShowModal={setShowAddressForm}
              handleClose={handleClose}
              setToEdit={setToEdit}
              setShowAddressForm={setShowAddressForm}
            />
          ) : (
            <ModalNext opened={true} onRequestClose={handleClose}>
              <AddressForm toEdit={toEdit} onClose={handleClose} />
            </ModalNext>
          )}
        </>
      )}
    </>
  );
});
